import React from 'react';
import { connect } from 'react-redux'
import Button from '../components/button';
import * as buildProductAction from './../action/buildProduct';
import { updateSCTags } from './../service/dtmTag';
import { InHomeUtils } from '../util/inhomeUtils';
import ReactHtmlParser from 'react-html-parser';
import { vzdlErrorUpdate } from '../service/vzdl';
import { ModalTitle, ModalBody } from '@vds/modals';
import { FiosReferralKeyboard } from '../containers/fiosRetailTablet/Keyboard/FiosReferralKeyboard';
class CouponInfo extends React.PureComponent {    
    constructor(props) {
        super(props);
        this.cursorPosition= '';
        this.state = {
            updateCoupanError:false,
            isKeyboardOpenForCoupon: false,
        }
        this.inputRef=React.createRef();
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
        this.keyboard = React.createRef();
    }   
    
    validateInput = (e) => {        
        let targetid = e.target.id;
        buildProductAction.validateInputcoupon({ [targetid]: e.target.value.trim().toUpperCase() }, this.props.dispatch);
        this.cursorPosition = e.target.selectionStart;
    }
    componentDidMount() {       
        if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && !this.props.buildProductState.couponInfo.referfriendvalidationsucess) {
            this.props.dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONRESULT', value: "" })
            this.props.dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONSUCESS', value: false })
            this.props.dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONFAILURE', value: false })
            this.props.dispatch({ type: 'COUPONEMPTY', value: "" })
        }
        if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && !this.props.buildProductState.ffCouponInfo.ffValidationSucess) {
            
            let ffValidationInfo = {
                ffValidationFailure: false,
                ffValidationErrorType: ''
            }
            this.props.dispatch({ type: 'FFCOUPONVALIDATIONFAILURE', value: ffValidationInfo });
            this.props.dispatch({ type: 'FFCOUPONEMPTY', value: "" })
        }
        if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) &&  this.props.buildProductState.vzcCouponInfo && !this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) {

            let vzcCouponInfo = {
                vzcValidationFailure: false
            }
            this.props.dispatch({ type: 'VZCCOUPONVALIDATION', value: vzcCouponInfo });
        }
        if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) &&  this.props.buildProductState.visPreCouponInfo && !this.props.buildProductState.visPreCouponInfo.visPreValidationSucess) {

            let visPreCouponInfo = {
                visPreValidationFailure: false
            }
            this.props.dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreCouponInfo });
        }

    } 
    componentDidUpdate() {
        const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";
        if (InHomeUtils.isNotNull(document.getElementById("referralCode")) && !hostedAttractLoop) {
            let referralCodeInput = document.getElementById("referralCode");            
            var selectionStart = this.cursorPosition;
            var selectionEnd = this.cursorPosition;
            if (referralCodeInput.setSelectionRange) {
                // referralCodeInput.focus();
                referralCodeInput.setSelectionRange(selectionStart, selectionEnd);
            }
            else if (referralCodeInput.createTextRange) {
                var range = referralCodeInput.createTextRange();
                range.collapse(true);
                range.moveEnd('character', selectionEnd);
                range.moveStart('character', selectionStart);
                range.select();
            }
        }

    }   
    submitRequest = () => {       
        updateSCTags("special offer - redeem");
        this.props.dispatch({ type: 'VZCOUPONREEDEMED', value: false });
        let allentered = true;        
        let couponType="";
        this.setState({
            updateCoupanError: true
        })
        let couponEntered=this.props.buildProductState && this.props.buildProductState.couponInfo && this.props.buildProductState.couponInfo.coupon && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon) ? this.props.buildProductState.couponInfo.coupon.trim():"";        
        if (couponEntered=== "") {            
            buildProductAction.couponErr(true, this.props.dispatch)
            allentered = false;
            if(this.inputRef.current){
                this.inputRef.current.focus();
                this.inputRef.current.style.setProperty('box-shadow', '0px 0px 0.3rem 0.25rem #109EE0','important');
             }
        }
        else { 
            if(couponEntered.length>2 && couponEntered.substring(couponEntered.length-2) === "VZ") 
            {
                couponType="RAF";
            }
            else if (new RegExp('^[FF]{2}').test(couponEntered)) {
                if (new RegExp('^[FF]{2}[a-zA-Z0-9]{5}$').test(couponEntered)) {
                    couponType = "FF";
                    this.props.dispatch({ type: "FFCOUPONVALIDATION", value: couponEntered });
                }
                else {
                    let ffValidationInfo = {
                        ffValidationFailure: true,
                        ffValidationErrorType: ''
                    }
                    this.props.dispatch({ type: 'FFCOUPONVALIDATIONFAILURE', value: ffValidationInfo });
                    let couponValidationMsg = "We're sorry, the referral code entered is not recognized. Please check and enter again.";
                    if (this.state.updateCoupanError) {
                        this.setState({
                            updateCoupanError: false
                        })
                        vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                    }
                }
            }
            else if( InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isVisiblePrepaidEnable) 
                    && this.props.runtimeKey.isVisiblePrepaidEnable === "Y" 
                    && (new RegExp('^[VISB]{4}').test(couponEntered) || new RegExp('^[PRPD]{4}').test(couponEntered))){
              
                couponType = "VISPRP";                    
                this.props.dispatch({ type: 'VISPRPCOUPONVALID', value: couponEntered });
                if((this.props.SweetnerMsgMFRT.discountEligible) || this.props.buildProductState.internet.mnhSignupIndicator === "Y"){
                    this.props.dispatch({ type: 'ISTWSANDMNH', value: true });
                    this.props.buildProductState.visPreCouponInfo.isMnhAndTWSAppied = true;
                }else{
                    this.props.dispatch({ type: 'ISTWSANDMNH', value: false });
                    this.props.buildProductState.visPreCouponInfo.isMnhAndTWSAppied = false;
                }
            } 
            else if (couponEntered.length == 14) {
                if (new RegExp('^[a-zA-Z0-9]{4}[-]{0,1}[a-zA-Z0-9]{4}[-]{0,1}[a-zA-Z0-9]{4}$').test(couponEntered) && InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isVZConnectionEnabled) && this.props.runtimeKey.isVZConnectionEnabled === "Y") {
                    couponType = "VZC";                    
                    this.props.dispatch({ type: 'VZCCOUPONVALID', value: couponEntered });
                }
            }
            else if(couponEntered.length == 16 && couponEntered.substring(0,5) === 'DAW01'){
                couponType = "VZC";                    
                this.props.dispatch({ type: 'VZCCOUPONVALID', value: couponEntered });
            }            
            buildProductAction.couponErr(false, this.props.dispatch)
        }
        if (allentered) {
            this.props.dispatch({ type: 'CURRENTCOUPONVALIDATION', value: couponType });            
            if(couponType==="RAF")
            {
                if (InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isRAFEnabled) && this.props.runtimeKey.isRAFEnabled === "Y") {
                    buildProductAction.referFrinedValidation(this.props.appState.visitId, this.props.isDoFlow, this.props.buildProductState.couponInfo.coupon, this.props.dispatch, this.props.appState.flowType);
                }                
                else{
                    //RAF Sunset Changes
                    this.props.dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONFAILURE', value: true })  
                } 
            }
            else if(couponType==="FF" && InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon))
            {
               buildProductAction.ffCouponValidation(this.props.appState.visitId, this.props.isDoFlow,this.props.appState.visitorId, this.props.buildProductState, this.props.dispatch);
            }            
            else if (couponType === "VZC" && InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isVZConnectionEnabled) && this.props.runtimeKey.isVZConnectionEnabled === "Y") {
                if (InHomeUtils.isNotNull(this.props.buildProductState) &&InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon)) {

                    buildProductAction.vzCouponValidation(this.props.appState.visitId, this.props.isDoFlow,this.props.buildProductState, this.props.dispatch);
                }
            }
            else if (couponType === "VISPRP" && InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isVisiblePrepaidEnable) && this.props.runtimeKey.isVisiblePrepaidEnable === "Y") {
                if (InHomeUtils.isNotNull(this.props.buildProductState) &&InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon) && (!this.props.buildProductState.visPreCouponInfo.isMnhAndTWSAppied)) {
                    buildProductAction.VISPRPCouponValidation(this.props.appState.visitId, this.props.isDoFlow,this.props.appState.visitorId, this.props.buildProductState, this.props.dispatch,this.props.isFCPflow,this.props.appState);
                }
            }
            if(!InHomeUtils.isNotEmpty(couponType) && InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon))
            {
                let ffValidationInfo = {                    
                    ffValidationFailure: true,
                    ffValidationErrorType:  'INCORRECT'                   
                }
                this.props.dispatch({ type: 'FFCOUPONVALIDATIONFAILURE', value: ffValidationInfo }); 
                let couponValidationMsg = "We're sorry, the referral code entered is not recognized. Please check and enter again.";
                if (this.state.updateCoupanError) {
                    this.setState({
                        updateCoupanError: false
                    })
                    vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                }
            }             
        }
    }  
handleBlur = () =>{
    this.inputRef.current.style.setProperty('box-shadow', 'none','important');
}

onKeyPress = buttonPressed => this.keyPressed = buttonPressed;

onKeyboardChange = (value) => {
    const targetid = "referralCode";
    buildProductAction.validateInputcoupon({ [targetid]: value.trim().toUpperCase() }, this.props.dispatch);
}
    

    render() {        
        const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";
        let couponInfoContent = "";
        let couponValidationMsg = "";
        if (InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && (InHomeUtils.isNotNull(this.props.buildProductState.couponInfo)&& InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo))&& (!this.props.buildProductState.couponInfo.isRAFCheckoutValidation && !this.props.buildProductState.ffCouponInfo.isFFCheckoutValidation && !this.props.buildProductState.visPreCouponInfo.isVisPreCheckoutValidation && !this.props.buildProductState.vzcCouponInfo.isvzcCheckoutValidation)){                       
            if (InHomeUtils.isNotEmpty(this.props.buildProductState.currentCouponType) && this.props.buildProductState.currentCouponType === "RAF") {
                if (this.props.buildProductState.couponInfo && this.props.buildProductState.couponInfo.referfriendvalidationsucess) {
                    if (InHomeUtils.isNotNull(this.props.isFCPflow) && this.props.isFCPflow) {
                        couponValidationMsg = "Your Refer a Friend or Coupon code has been validated, add 1GB internet to any package and receive a $100 Prepaid Mastercard.";
                    }
                    else {
                        couponValidationMsg = "Your Refer a Friend or Coupon code has been validated.  Add a qualifying Verizon Triple Play, Double Play or Fios Gigabit Connection to your cart and you both may qualify for a Refer a Friend gift card.";
                    }

                }
                else if (this.props.buildProductState.couponInfo && this.props.buildProductState.couponInfo.referfriendvalidationfailure) {
                    if (InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isRAFEnabled) && this.props.runtimeKey.isRAFEnabled === "Y") {
                        couponValidationMsg = "We're sorry, the referral code entered is not recognized. Please check and enter again.";
                        if (this.state.updateCoupanError) {
                            this.setState({
                                updateCoupanError: false
                            })
                            vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                        }
                    }
                    else {
                        //RAF Sunset Changes
                        couponValidationMsg = "We're sorry, the special code you entered is not recognized. Please try again.";
                        if (this.state.updateCoupanError) {
                            this.setState({
                                updateCoupanError: false
                            })
                            vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                        }
                    }
                }

            }
             // vzc changes
            else if (InHomeUtils.isNotEmpty(this.props.buildProductState.currentCouponType) && this.props.buildProductState.currentCouponType === "VZC" && InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isVZConnectionEnabled) && this.props.runtimeKey.isVZConnectionEnabled === "Y") {
                if (this.props.buildProductState.vzcCouponInfo && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess) {
                    if (this.props.buildProductState.vzcCouponInfo.isDiscountEligible && this.props.buildProductState.vzcCouponInfo.isDiscountApplied){                    
                    couponValidationMsg+="<div>&#x2714; &nbsp;"+"The Deals at Work has been applied to your cart."+"</div>";
                    }
                    else if(this.props.buildProductState.vzcCouponInfo.isDiscountEligible && !this.props.buildProductState.vzcCouponInfo.isDiscountApplied){
                    couponValidationMsg = "Your Deals at Work Code has been validated. Internet and/or Voice is required to be added to your cart in order to be eligible for the discount.";
                    }
                }
                else if (this.props.buildProductState.vzcCouponInfo && this.props.buildProductState.vzcCouponInfo.vzcValidationFailure) {                   
                    couponValidationMsg = "We're sorry the special offer code you entered is not recognized. Please try again.";
                    if (this.state.updateCoupanError) {
                        this.setState({
                            updateCoupanError: false
                        })
                        vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                    }
                }
            }
            else if (InHomeUtils.isNotEmpty(this.props.buildProductState.currentCouponType) && this.props.buildProductState.currentCouponType === "FF") {
                if (this.props.buildProductState.ffCouponInfo && this.props.buildProductState.ffCouponInfo.ffValidationSucess) {
                    couponValidationMsg = "Your Friends and Family code has been validated. The Gigabit Connection internet plan (or highest speed) is required to be eligible for the $10/mo discount.";
                }
                else if (this.props.buildProductState.ffCouponInfo && this.props.buildProductState.ffCouponInfo.ffValidationFailure && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffValidationErrorType)) {
                    if (this.props.buildProductState.ffCouponInfo.ffValidationErrorType === "MAXUSEDEXPIRED") {
                        couponValidationMsg = "This code has no more uses.  Please check with the person who sent you the code.";
                        if (this.state.updateCoupanError) {
                            this.setState({
                                updateCoupanError: false
                            })
                            vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                        }
                    }
                    else if (this.props.buildProductState.ffCouponInfo.ffValidationErrorType === "INVALID") {
                        couponValidationMsg = "This code isn't valid. Please try again or check with the person who sent you the code.";
                        if (this.state.updateCoupanError) {
                            this.setState({
                                updateCoupanError: false
                            })
                            vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                        }
                    }

                }

            }
            else if (InHomeUtils.isNotEmpty(this.props.buildProductState.currentCouponType) && this.props.buildProductState.currentCouponType === "VISPRP") {
                if (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationSucess) {
                    if(this.props.buildProductState.visPreCouponInfo.isDiscountEligible && this.props.buildProductState.visPreCouponInfo.isDiscountApplied ){
                    couponValidationMsg = "Promo code applied.";
                    }
                    else if( !this.props.buildProductState.visPreCouponInfo.isDiscountEligible && this.props.buildProductState.visPreCouponInfo.isDiscountApplied){
                    couponValidationMsg = "For this discount, you need to select an internet plan to be eligible.";    
                    }
                    else if( !this.props.buildProductState.visPreCouponInfo.isDiscountEligible){
                        couponValidationMsg = "For this discount, you need to select an internet plan to be eligible.";    
                    }else{
                        couponValidationMsg = "Promo code applied.";
                    }
                }
                else if (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.isMnhAndTWSAppied) {
                    couponValidationMsg = "Promo code cannot be applied with another offer on your order.";
                    if (this.state.updateCoupanError) {
                        this.setState({
                            updateCoupanError: false
                        })
                        vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                    }
                }
                else if (this.props.buildProductState.visPreCouponInfo && this.props.buildProductState.visPreCouponInfo.visPreValidationFailure && InHomeUtils.isNotEmpty(this.props.buildProductState.visPreCouponInfo.visPreValidationFailure)) {
                    if (this.props.buildProductState.visPreCouponInfo.visPreValidationErrorType && this.props.buildProductState.visPreCouponInfo.visPreValidationErrorType === "MAXUSEDEXPIRED") {
                        couponValidationMsg = "Promo code already redeemed.";
                    }else{
                        couponValidationMsg = "Promo code cannot be applied.";
                    }
                    if (this.state.updateCoupanError) {
                        this.setState({
                            updateCoupanError: false
                        })
                        vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                    }
                }            
            }
            else if(InHomeUtils.isNotEmpty(this.props.buildProductState.currentCouponType) && this.props.buildProductState.currentCouponType === "InValidVISPRP"){
                couponValidationMsg = "Promo code not found.";
                if (this.state.updateCoupanError) {
                    this.setState({
                        updateCoupanError: false
                    })
                    vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                }
            }
            else if ((!InHomeUtils.isNotEmpty(this.props.buildProductState.currentCouponType) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffValidationErrorType) && this.props.buildProductState.ffCouponInfo.ffValidationErrorType === "INCORRECT")||(InHomeUtils.isNotEmpty(this.props.buildProductState.currentCouponType) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffValidationErrorType) && this.props.buildProductState.ffCouponInfo.ffValidationErrorType === "TRANSACTIONFAILED")) {
                if(this.inputRef.current){
                    this.inputRef.current.focus();
                 }
                couponValidationMsg = "We're sorry, the referral code entered is not recognized. Please check and enter again.";
                if (this.state.updateCoupanError) {
                    this.setState({
                        updateCoupanError: false
                    })
                    vzdlErrorUpdate("", couponValidationMsg, "event11,prodView");
                }
            }            
            couponInfoContent = <div>
                {/* <div className="modal_header"><h5 className="margin-top-zero">Redeem now</h5></div>
                <div className="modal_content fixModalHeight"> */}
                <ModalTitle>
                    Redeem now                                       
                </ModalTitle>
                <ModalBody>
                    <div className={this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || this.props.buildProductState.visPreCouponInfo.visPreValidationSucess || this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess ? "hide" : "validation-wrap margin-top-tiny"}>
                    <label htmlFor="referralCode" className={this.isReskin ? "labelReskinforCustomLabel" : ""}>{(InHomeUtils.isNotNull(this.props.runtimeKey) && InHomeUtils.isNotEmpty(this.props.runtimeKey.isRAFEnabled) && this.props.runtimeKey.isRAFEnabled === "Y")?"Enter your Refer a Friend or Coupon code":"Enter your Coupon code"}</label>
                    <input onClick={() => { this.setState({ isKeyboardOpenForCoupon: true })}} aria-label={this.props.buildProductState.couponInfo.couponerror?'Please enter coupon':''} ref={this.inputRef} type="text" id="referralCode" data-cs-mask tabIndex="0" className={this.isReskin ? "inputReskinForCustomInputFiled tiny-12" : "tiny-12 value"} autoFocus={false}
                            alphabets="[^a-zA-Z\-\s]" placeholder="Enter code" onChange={!hostedAttractLoop && this.validateInput} onBlur={this.handleBlur} value={this.props.buildProductState.couponInfo.coupon.toUpperCase()}
                        />
                        <div className={this.props.buildProductState.couponInfo.couponerror ? "margin-horiz-small text-alert bold" : "hide"}>Please enter coupon</div>
                    </div>                    
                    {/* <div className={this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess || this.props.buildProductState.couponInfo.referfriendvalidationfailure || this.props.buildProductState.ffCouponInfo.ffValidationFailure || this.props.buildProductState.vzcCouponInfo.vzcValidationFailure ? "" : "hide"}> */}
                        <p id="rafMsg" role="alert" aria-live="assertive" className={this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess && this.props.buildProductState.vzcCouponInfo.isDiscountEligible && this.props.buildProductState.vzcCouponInfo.isDiscountApplied ? "margin-horiz-small bold" : "margin-horiz-small text_red text_bold"}>                                
                            {!this.props.buildProductState.vzcCouponInfo.vzcCouponRedeemed ? ReactHtmlParser(couponValidationMsg) : 'Promo code already redeemed.'}
                        </p>                        
                    {/* </div> */}
                    {!this.props.buildProductState.vzcCouponInfo.vzcCouponRedeemed && <div className={this.props.buildProductState.referafriendcallstart || this.props.buildProductState.ffCallStart || this.props.buildProductState.visPreCallStart || this.props.buildProductState.vzccValidationStart? "margin-horiz-small text-alert bold" : "hide"}>
                        <div className="section-overlay"><div className="row section-loader vert-middle margin-vert-zero fluid-grid hide"><div className="column padding-vert-zero section-overlay-column">
                            <div className="margin-top-small text-medium bold" role="alert" aria-busy="true" aria-live="assertive">
                                <div className="spin-loader"></div><div className="loader-messgae"></div>
                            </div></div></div></div>
                    </div>}
                    <div className={this.props.buildProductState.couponInfo.referfriendvalidationsucess || this.props.buildProductState.ffCouponInfo.ffValidationSucess || this.props.buildProductState.visPreCouponInfo.visPreValidationSucess || this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess ? "hide" : "redeemButton margin-top-xlarge modalFooterButtonReskin2"}>
                        <Button buttonStyle="button tiny-12 medium-4" onClick={this.submitRequest} buttonText="Redeem" />
                        {/* disableButton={this.props.buildProductState.couponInfo.coupon === "" ? true : false}  */}
                    </div>
                    <FiosReferralKeyboard
                        keyboardContainerClass={"keyboard-container-for-save-email"}
                        showKeyboard={this.state.isKeyboardOpenForCoupon}
                        closeKeyboard={() => this.setState({ isKeyboardOpenForCoupon: false })}
                        theme={"plantools"}
                        inputName={"coupoun"}
                        keyboard={this.keyboard}
                        onChange={this.onKeyboardChange}
                        onKeyPress={this.onKeyPress}
                     />
                {/* </div> */}
                </ModalBody>
            </div>;
        } else if (InHomeUtils.isNotNull(this.props.buildProductState) && (InHomeUtils.isNotNull(this.props.buildProductState.couponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo)) && (this.props.buildProductState.couponInfo.isRAFCheckoutValidation || this.props.buildProductState.ffCouponInfo.isFFCheckoutValidation || this.props.buildProductState.vzcCouponInfo.isvzcCheckoutValidation)) {
            let couponCheckoutValidationMsg = "";
            let couponCheckoutValidationTitleMsg = "";
            let noThankscontinueToCheckoutMsg = "";
            let selectValidPackage="";
            if (InHomeUtils.isNotNull(this.props.buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.couponInfo.coupon) && this.props.buildProductState.couponInfo.referfriendvalidationsucess && this.props.buildProductState.couponInfo.isRAFCheckoutValidation) {
                couponCheckoutValidationTitleMsg = "Looks like you chose a package that isn't eligible for the Refer A Friend reward.";
                noThankscontinueToCheckoutMsg = "Continue without Refer A Friend reward";
                selectValidPackage="Choose another package";

                if (InHomeUtils.isNotNull(this.props.isFCPflow) && this.props.isFCPflow) {
                    couponCheckoutValidationMsg = "Only packages that include 1GB are eligible for the Refer a Friend reward.";
                }
                else {
                    couponCheckoutValidationMsg = "Only Standalone Gigabit, Double or Triple Play packages are eligible for the Refer a Friend reward.";
                }

            }
            else if (InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.ffCouponInfo.ffCoupon) && this.props.buildProductState.ffCouponInfo.ffValidationSucess && this.props.buildProductState.ffCouponInfo.isFFCheckoutValidation) {
                couponCheckoutValidationTitleMsg = "Looks like you chose a package that isn't eligible for the Friend & Family discount.";
                noThankscontinueToCheckoutMsg = "Continue without Friend & Family discount";
                selectValidPackage="Choose another package";               
                couponCheckoutValidationMsg = "The Gigabit Connection internet plan (or highest speed) is required to be eligible for the $10/mo discount.";               

            }
            else if(InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && InHomeUtils.isNotEmpty(this.props.buildProductState.vzcCouponInfo.vzcCoupon) && this.props.buildProductState.vzcCouponInfo.vzcValidationSuccess && this.props.buildProductState.vzcCouponInfo.isvzcCheckoutValidation){
                couponCheckoutValidationTitleMsg = "Looks like you chose services that aren't eligible for a discount.";
                noThankscontinueToCheckoutMsg = "Continue without discount";
                selectValidPackage="Add Internet and/or Voice";
                couponCheckoutValidationMsg = "Either internet and/or Voice is required to be added to your plan to be eligible for the Verizon Connections discount.";
            }
            couponInfoContent = <div>
                <div className="modal_header"></div>
                <div className="footerDisclaimer t_charcoal modal_content fixModalHeight">
                    <div className="row margin-top-tiny"></div>
                    <div className="margin-top-zero">
                        <h5>{couponCheckoutValidationTitleMsg}</h5>
                    </div>
                    <div className="margin-top-zero">
                        <p>{couponCheckoutValidationMsg}</p>
                    </div>
                    <div className="row margin-top-tiny">
                        <div className="columns tiny-12 small-6 OwnRouterContinue_button" style={{ 'textAlign': 'center' }}>
                            <div className="margin-horiz-zero">
        <button type="button" id="COUPON" tabIndex="0" className="button tiny-10 margin-top-tiny" onClick={this.props.rafCloseModal}>{selectValidPackage}</button>
                            </div>
                        </div>
                        <div className="column tiny-12 small-6 OwnRouterContinue_button" style={{ 'textAlign': 'center' }}>
                            <div className="margin-horiz-zero" style={{ 'paddingTop': '1.35rem', 'paddingLeft': '0.5625rem' }}>
                                <a className="bold text-hyperlink tiny-10 margin-top-tiny" id="COUPON" onClick={this.props.noThanksContinueToCheckout}><span className="screen-reader-only">Open modal with</span> {noThankscontinueToCheckoutMsg}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>;
        }
        return (
            <div>
                {couponInfoContent}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        buildProductState: state.buildProduct,
        appState: state.app,
        isFCPflow: state.loopQual.isFCPflow,
        runtimeKey:state.loopQual.runtimeKey,
        SweetnerMsgMFRT: state.loopQual.sweetnerMsgMFRT,
    }
}
export default connect(
    mapStateToProps
)(CouponInfo);
